import SidebarController from "./sidebar_controller.js";
import AppHeaderController from "./app_header_controller.js";
import NavController from "./nav_controller.js";
import AuthLoginController from "./auth_login_controller.js";
import AuthForgotController from "./auth_forgot_controller.js";
import AuthResetController from "./auth_reset_controller.js";
import AuthSignupController from "./auth_signup_controller.js";
import AuthSignupSuccessController from "./auth_signup_success_controller.js";
import AuthVerifyEmailController from "./auth_verify_email_controller.js";
import AuthLogoutController from "./auth_logout_controller.js";
import DashboardRouterController from "./dashboard_router_controller.js";
import DashboardProspectController from "./dashboard_prospect_controller.js";
import DashboardPayantController from "./dashboard_payant_controller.js";
import DashboardCfePaidController from "./dashboard_cfe_paid_controller.js";
import DashboardArceInlineController from "./dashboard_arce_inline_controller.js";
import DashboardReferralController from "./dashboard_referral_controller.js";
import ActivityFeedBlockController from "./activity_feed_block_controller.js";
import ActivityFeedPageController from "./activity_feed_page_controller.js";
import UpcomingObligationsBlockController from "./upcoming_obligations_block_controller.js";
import UpcomingObligationsPageController from "./upcoming_obligations_page_controller.js";
import PersonalRemindersSuggestionsController from "./personal_reminders_suggestions_controller.js";
import PersonalRemindersLibraryController from "./personal_reminders_library_controller.js";
import PersonalRemindersDetailController from "./personal_reminders_detail_controller.js";
import ActiviteEditionController from "./activite_edition_controller.js";
import ProfileEntrepriseActivityContextController from "./profile_entreprise_activity_context_controller.js";
import DemarrageCreationController from "./demarrage_creation_controller.js";
import DemarrageExistanteController from "./demarrage_existante_controller.js";
import SubscriptionViewController from "./subscription_view_controller.js";
import CheckoutReturnController from "./checkout_return_controller.js";
import SettingsPaymentProviderController from "./settings_payment_provider_controller.js";
import SettingsIbanOnPdfController from "./settings_iban_on_pdf_controller.js";
import SettingsTabsController from "./settings_tabs_controller.js";
import SettingsPaymentConditionsController from "./settings_payment_conditions_controller.js";
import SettingsAdvancedController from "./settings_advanced_controller.js";
import NumberingPatternController from "./numbering_pattern_controller.js";
import InvoiceReminderTemplatesListController from "./invoice_reminder_templates_list_controller.js";
import InvoiceReminderTemplateEditController from "./invoice_reminder_template_edit_controller.js";
import AidesWizardController from "./aides_wizard_controller.js";
import OnboardingWizardController from "./onboarding_wizard_controller.js";
import OnboardingGateController from "./onboarding_gate_controller.js";
import ActivitiesListController from "./activities_list_controller.js";
import ActivityFormController from "./activity_form_controller.js";
import ClientsListController from "./clients_list_controller.js";
import ClientsDetailController from "./clients_detail_controller.js";
import ClientsFormController from "./clients_form_controller.js";
import ArticlesListController from "./articles_list_controller.js";
import SearchResultsController from "./search_results_controller.js";
import ArticlesDetailController from "./articles_detail_controller.js";
import ArticlesFormController from "./articles_form_controller.js";
import InpiFormalityStatusController from "./inpi_formality_status_controller.js";
import ProfileEntrepriseMediationController from "./profile_entreprise_mediation_controller.js";
import ProfileEntrepriseBankController from "./profile_entreprise_bank_controller.js";
import ProfileEntrepriseIdentiteController from "./profile_entreprise_identite_controller.js";
import ProfileEntrepriseFiscalController from "./profile_entreprise_fiscal_controller.js";
import CfeSettingsController from "./cfe_settings_controller.js";
import ProfileUserSecuriteController from "./profile_user_securite_controller.js";
import ProfileUserIdentiteController from "./profile_user_identite_controller.js";
import RgpdExportController from "./rgpd_export_controller.js";
import RgpdAccountDeletionController from "./rgpd_account_deletion_controller.js";
import ResignationWizardController from "./resignation_wizard_controller.js";
import ResignationBannerController from "./resignation_banner_controller.js";
import LifecycleReadonlySidebarController from "./lifecycle_readonly_sidebar_controller.js";
import CessationInpiController from "./cessation-inpi_controller.js";
import DocumentsListeController from "./documents_liste_controller.js";
import VaultListController from "./vault_list_controller.js";
import VaultDetailController from "./vault_detail_controller.js";
import VaultImportController from "./vault_import_controller.js";
import InsuranceExpirationBannerController from "./insurance_expiration_banner_controller.js";
import IssuanceGateController from "./issuance_gate_controller.js";
import FileUploadController from "./file_upload_controller.js";
import InpiRegularizationController from "./inpi_regularization_controller.js";
import InpiRedirectionSignatureController from "./inpi_redirection_signature_controller.js";
import WizardCreationController from "./wizard_creation_controller.js";
import QuotesListController from "./quotes_list_controller.js";
import QuoteDetailController from "./quote_detail_controller.js";
import QuoteEditController from "./quote_edit_controller.js";
import DevisFacturerController from "./devis-facturer_controller.js";
import InvoicesListController from "./invoices_list_controller.js";
import InvoiceDetailController from "./invoice_detail_controller.js";
import InvoiceFormController from "./invoice_form_controller.js";
// EPIC-042 / 42.5 (D1) — payment_entry_modal_controller supprimé : la
// saisie de paiement passe désormais par la page dédiée
// /paiements-edition.html (controller `payments-edition`).
import PaymentsEditionController from "./payments_edition_controller.js";
import PaymentsListController from "./payments_list_controller.js";
// Composant transverse combobox recherchable (EPIC-099.50) — sélecteurs
// d'entité à fort cardinal (client, article…).
import SearchableSelectController from "./searchable_select_controller.js";
import PaymentsPendingController from "./payments_pending_controller.js";
// EPIC-045 / 45.7 — Carnet PDF imprimable des transactions SumUp (§7.K.F).
import PaymentsCarnetController from "./payments_carnet_controller.js";
// EPIC-043 / 43.4 — Caisse espèces (§7.J).
import CashRegisterListController from "./cash_register_list_controller.js";
import CashRegisterEditionController from "./cash_register_edition_controller.js";
import CashRegisterSessionController from "./cash_register_session_controller.js";
// EPIC-043 / 43.5 — Caisse espèces : pages avancées (§7.J.C/D).
// 99.19 — Clôture déplacée en bloc inline dans `cash-register-session` (page
// /caisse-cloture.html supprimée), le controller dédié `cash-register-close`
// n'existe plus.
import CashRegisterMovementController from "./cash_register_movement_controller.js";
import CashRegisterTransactionPendingController from "./cash_register_transaction_pending_controller.js";
// EPIC-099.20 — pastille de présence sidebar §7.J.A.
import CashRegisterSidebarController from "./cash_register_sidebar_controller.js";
import PaymentProvidersListController from "./payment_providers_list_controller.js";
import PaymentProvidersEditionController from "./payment_providers_edition_controller.js";
// EPIC-045 / 45.5 — Connector SumUp
import PaymentProvidersDisconnectSumupController from "./payment_providers_disconnect_sumup_controller.js";
import InvoiceRequestRejectController from "./invoice_request_reject_controller.js";
import RemindersListController from "./reminders_list_controller.js";
import RecurrenceListController from "./recurrence_list_controller.js";
import RecurrenceDetailController from "./recurrence_detail_controller.js";
import RecurrenceEditionController from "./recurrence_edition_controller.js";
import RevenueRegisterController from "./revenue_register_controller.js";
import RevenueRegisterDetailController from "./revenue_register_detail_controller.js";
import RevenueRegisterManualEntryController from "./revenue_register_manual_entry_controller.js";
import RevenueRegisterMonthConfirmController from "./revenue_register_month_confirm_controller.js";
import RevenueRegisterYearCloseController from "./revenue_register_year_close_controller.js";
import PurchaseInvoicesListController from "./purchase_invoices_list_controller.js";
import PurchaseInvoiceDetailController from "./purchase_invoice_detail_controller.js";
import PurchaseRegisterConsultationController from "./purchase_register_consultation_controller.js";
import PurchaseRegisterProcessingController from "./purchase_register_processing_controller.js";
import PurchaseRegisterManualEntryController from "./purchase_register_manual_entry_controller.js";
import SeuilsDashboardController from "./seuils_dashboard_controller.js";
import VatIntracomRequestController from "./vat_intracom_request_controller.js";
import TvaRegimeComparatorController from "./tva_regime_comparator_controller.js";
import VatExitWizardController from "./vat_exit_wizard_controller.js";
import TvaDeclarationFormController from "./tva_declaration_form_controller.js";
import TvaSubmitModalController from "./tva_submit_modal_controller.js";
import UrssafDeclarationController from "./urssaf_declaration_controller.js";
import IncomeTaxController from "./income_tax_controller.js";
import AcreDemandeController from "./acre_demande_controller.js";
import FranceTravailController from "./france_travail_controller.js";
import Das2ListController from "./das2_list_controller.js";
import Das2BeneficiaryFormController from "./das2_beneficiary_form_controller.js";
import Das2DeclarationController from "./das2_declaration_controller.js";
import Das2SubmissionController from "./das2_submission_controller.js";
import SimulatorFormController from "./simulator_form_controller.js";
import SimulatorResultsController from "./simulator_results_controller.js";
import ScenarioSwitcherController from "./scenario_switcher_controller.js";
import ScenarioComparatorController from "./scenario_comparator_controller.js";
import SimulatorPrintController from "./simulator_print_controller.js";
import SimulatorGuideController from "./simulator_guide_controller.js";
import SvgGraphController from "./svg_graph_controller.js";
import ActivityAdditionFormController from "./activity_addition_form_controller.js";
import ActivityAdditionResultsController from "./activity_addition_results_controller.js";
import ScenarioSaveController from "./scenario_save_controller.js";
import PilotageHubController from "./pilotage_hub_controller.js";
import PilotageConcentrationController from "./pilotage_concentration_controller.js";
import PilotageTjmController from "./pilotage_tjm_controller.js";
// EPIC-047 / 47.4 — Trajectoire CA (§16.E) : 3 surfaces frontend ME.
import TrajectoireViewController from "./trajectoire_view_controller.js";
import TrajectoireEditionController from "./trajectoire_edition_controller.js";
import TrajectoireWidgetController from "./trajectoire_widget_controller.js";
import TrajectoireBannerController from "./trajectoire_banner_controller.js";
import TrajectoireChartController from "./trajectoire_chart_controller.js";
// EPIC-047 / 47.5 — intégration simulateurs §17.A + §17.B.
import SimulatorTrajectoryController from "./simulator_trajectory_controller.js";
import NotificationsOptOutController from "./notifications_opt_out_controller.js";
import NotificationsInboxController from "./notifications_inbox_controller.js";
import NotificationsInboxDetailController from "./notifications_inbox_detail_controller.js";
import ConversionTrackerController from "./conversion-tracker_controller.js";
import RestrictedFeatureModalController from "./restricted-feature-modal_controller.js";
import AudienceController from "./audience_controller.js";
// EPIC-048 / 48.3 — Favoris : bouton ⭐ topbar + sidebar dynamique (§28.F).
import FavoritesToggleController from "./favorites_toggle_controller.js";
import FavoritesSidebarController from "./favorites_sidebar_controller.js";
// EPIC-048 / 48.4 — Favoris : onglet « Menu favoris » du profil (§28.F.3).
import FavoritesManagerController from "./favorites_manager_controller.js";
// EPIC-063 / 63.2 — Champ « Code parrainage (optionnel) » sur les pages
// d'activation (demarrage-existante / demarrage-creation).
import ReferralCodeFieldController from "./referral_code_field_controller.js";
// EPIC-066 / 66.6 — page Finances (mouvements encaissés / à encaisser /
// payés / à payer + accumulation URSSAF) — §31.
import FinancesController from "./finances_controller.js";

const application = window.Stimulus;

application.register("sidebar", SidebarController);
application.register("app-header", AppHeaderController);
application.register("nav", NavController);
application.register("auth-login", AuthLoginController);
application.register("auth-forgot", AuthForgotController);
application.register("auth-reset", AuthResetController);
application.register("auth-signup", AuthSignupController);
application.register("auth-signup-success", AuthSignupSuccessController);
application.register("auth-verify-email", AuthVerifyEmailController);
application.register("auth-logout", AuthLogoutController);
application.register("dashboard-router", DashboardRouterController);
application.register("dashboard-prospect", DashboardProspectController);
application.register("dashboard-payant", DashboardPayantController);
application.register("dashboard-cfe-paid", DashboardCfePaidController);
application.register("dashboard-arce-inline", DashboardArceInlineController);
application.register("dashboard-referral", DashboardReferralController);
application.register("activity-feed-block", ActivityFeedBlockController);
application.register("activity-feed-page", ActivityFeedPageController);
application.register("upcoming-obligations-block", UpcomingObligationsBlockController);
application.register("upcoming-obligations-page", UpcomingObligationsPageController);
application.register("personal-reminders-suggestions", PersonalRemindersSuggestionsController);
application.register("personal-reminders-library", PersonalRemindersLibraryController);
application.register("personal-reminders-detail", PersonalRemindersDetailController);
application.register("activite-edition", ActiviteEditionController);
application.register("profile-entreprise-activity-context", ProfileEntrepriseActivityContextController);
application.register("demarrage-creation", DemarrageCreationController);
application.register("demarrage-existante", DemarrageExistanteController);
application.register("subscription-view", SubscriptionViewController);
application.register("checkout-return", CheckoutReturnController);
application.register("settings-payment-provider", SettingsPaymentProviderController);
application.register("settings-iban-on-pdf", SettingsIbanOnPdfController);
application.register("settings-tabs", SettingsTabsController);
application.register("settings-payment-conditions", SettingsPaymentConditionsController);
application.register("settings-advanced", SettingsAdvancedController);
application.register("numbering-pattern", NumberingPatternController);
application.register("invoice-reminder-templates-list", InvoiceReminderTemplatesListController);
application.register("invoice-reminder-template-edit", InvoiceReminderTemplateEditController);
application.register("aides-wizard", AidesWizardController);
application.register("onboarding-wizard", OnboardingWizardController);
application.register("onboarding-gate", OnboardingGateController);
application.register("activities-list", ActivitiesListController);
application.register("activity-form", ActivityFormController);
application.register("clients-list", ClientsListController);
application.register("clients-detail", ClientsDetailController);
application.register("clients-form", ClientsFormController);
application.register("articles-list", ArticlesListController);
application.register("search-results", SearchResultsController);
application.register("articles-detail", ArticlesDetailController);
application.register("articles-form", ArticlesFormController);
application.register("inpi-formality-status", InpiFormalityStatusController);
application.register("profile-entreprise-mediation", ProfileEntrepriseMediationController);
application.register("profile-entreprise-bank", ProfileEntrepriseBankController);
application.register("profile-entreprise-identite", ProfileEntrepriseIdentiteController);
application.register("profile-entreprise-fiscal", ProfileEntrepriseFiscalController);
application.register("cfe-settings", CfeSettingsController);
application.register("profile-user-securite", ProfileUserSecuriteController);
application.register("profile-user-identite", ProfileUserIdentiteController);
application.register("rgpd-export", RgpdExportController);
application.register("rgpd-account-deletion", RgpdAccountDeletionController);
application.register("resignation-wizard", ResignationWizardController);
application.register("resignation-banner", ResignationBannerController);
application.register("lifecycle-readonly-sidebar", LifecycleReadonlySidebarController);
application.register("cessation-inpi", CessationInpiController);
application.register("documents-liste", DocumentsListeController);
application.register("vault-list", VaultListController);
application.register("vault-detail", VaultDetailController);
application.register("vault-import", VaultImportController);
application.register("insurance-expiration-banner", InsuranceExpirationBannerController);
application.register("issuance-gate", IssuanceGateController);
application.register("file-upload", FileUploadController);
application.register("inpi-regularization", InpiRegularizationController);
application.register("inpi-redirection-signature", InpiRedirectionSignatureController);
application.register("wizard-creation", WizardCreationController);
application.register("quotes-list", QuotesListController);
application.register("quote-detail", QuoteDetailController);
application.register("quote-edit", QuoteEditController);
application.register("devis-facturer", DevisFacturerController);
application.register("invoices-list", InvoicesListController);
application.register("invoice-detail", InvoiceDetailController);
application.register("invoice-form", InvoiceFormController);
application.register("searchable-select", SearchableSelectController);
application.register("payments-edition", PaymentsEditionController);
application.register("payments-list", PaymentsListController);
application.register("payments-pending", PaymentsPendingController);
application.register("payments-carnet", PaymentsCarnetController);
application.register("cash-register-list", CashRegisterListController);
application.register("cash-register-edition", CashRegisterEditionController);
application.register("cash-register-session", CashRegisterSessionController);
application.register("cash-register-movement", CashRegisterMovementController);
application.register("cash-register-transaction-pending", CashRegisterTransactionPendingController);
application.register("cash-register-sidebar", CashRegisterSidebarController);
application.register("payment-providers-list", PaymentProvidersListController);
application.register("payment-providers-edition", PaymentProvidersEditionController);
application.register("payment-providers-disconnect-sumup", PaymentProvidersDisconnectSumupController);
application.register("invoice-request-reject", InvoiceRequestRejectController);
application.register("reminders-list", RemindersListController);
application.register("recurrence-list", RecurrenceListController);
application.register("recurrence-detail", RecurrenceDetailController);
application.register("recurrence-edition", RecurrenceEditionController);
application.register("revenue-register", RevenueRegisterController);
application.register("revenue-register-detail", RevenueRegisterDetailController);
application.register("revenue-register-manual-entry", RevenueRegisterManualEntryController);
application.register("revenue-register-month-confirm", RevenueRegisterMonthConfirmController);
application.register("revenue-register-year-close", RevenueRegisterYearCloseController);
application.register("purchase-invoices-list", PurchaseInvoicesListController);
application.register("purchase-invoice-detail", PurchaseInvoiceDetailController);
application.register("purchase-register-consultation", PurchaseRegisterConsultationController);
application.register("purchase-register-processing", PurchaseRegisterProcessingController);
application.register("purchase-register-manual-entry", PurchaseRegisterManualEntryController);
application.register("seuils-dashboard", SeuilsDashboardController);
application.register("vat-intracom-request", VatIntracomRequestController);
application.register("tva-regime-comparator", TvaRegimeComparatorController);
application.register("vat-exit-wizard", VatExitWizardController);
application.register("tva-declaration-form", TvaDeclarationFormController);
application.register("tva-submit-modal", TvaSubmitModalController);
application.register("urssaf-declaration", UrssafDeclarationController);
application.register("income-tax", IncomeTaxController);
application.register("acre-demande", AcreDemandeController);
application.register("france-travail", FranceTravailController);
application.register("das2-list", Das2ListController);
application.register("das2-beneficiary-form", Das2BeneficiaryFormController);
application.register("das2-declaration", Das2DeclarationController);
application.register("das2-submission", Das2SubmissionController);
application.register("simulator-form", SimulatorFormController);
application.register("simulator-results", SimulatorResultsController);
application.register("scenario-switcher", ScenarioSwitcherController);
application.register("scenario-comparator", ScenarioComparatorController);
application.register("simulator-print", SimulatorPrintController);
application.register("simulator-guide", SimulatorGuideController);
application.register("svg-graph", SvgGraphController);
application.register("activity-addition-form", ActivityAdditionFormController);
application.register("activity-addition-results", ActivityAdditionResultsController);
application.register("scenario-save", ScenarioSaveController);
application.register("pilotage-hub", PilotageHubController);
application.register("pilotage-concentration", PilotageConcentrationController);
application.register("pilotage-tjm", PilotageTjmController);
application.register("trajectoire-view", TrajectoireViewController);
application.register("trajectoire-edition", TrajectoireEditionController);
application.register("trajectoire-widget", TrajectoireWidgetController);
application.register("trajectoire-banner", TrajectoireBannerController);
application.register("trajectoire-chart", TrajectoireChartController);
application.register("simulator-trajectory", SimulatorTrajectoryController);
application.register("notifications-opt-out", NotificationsOptOutController);
application.register("notifications-inbox", NotificationsInboxController);
application.register("notifications-inbox-detail", NotificationsInboxDetailController);
application.register("conversion-tracker", ConversionTrackerController);
application.register("restricted-feature-modal", RestrictedFeatureModalController);
application.register("audience", AudienceController);
application.register("favorites-toggle", FavoritesToggleController);
application.register("favorites-sidebar", FavoritesSidebarController);
application.register("favorites-manager", FavoritesManagerController);
application.register("referral-code-field", ReferralCodeFieldController);
application.register("finances-page", FinancesController);
